import { render, staticRenderFns } from "./zzddmj.vue?vue&type=template&id=64458dee&scoped=true&"
import script from "./zzddmj.vue?vue&type=script&lang=js&"
export * from "./zzddmj.vue?vue&type=script&lang=js&"
import style0 from "./zzddmj.vue?vue&type=style&index=0&id=64458dee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64458dee",
  null
  
)

export default component.exports